import { Backgrounds, GapX, GapY, Grid } from "@makeswift/prop-controllers";
import { MakeswiftComponentType } from "../constants";
import { lazy } from "react";
function registerComponent(runtime) {
  return runtime.registerComponent(
    lazy(() => import("./Root")),
    {
      type: MakeswiftComponentType.Root,
      label: "Page",
      hidden: true,
      props: {
        children: Grid(),
        backgrounds: Backgrounds(),
        rowGap: GapY(),
        columnGap: GapX()
      }
    }
  );
}
export {
  registerComponent
};
//# sourceMappingURL=register.js.map